import React from "react";
import { toast } from "react-toastify";

export function Toast(msg) {
  return toast(msg, {
    position: "bottom-right",
    autoClose: 3000,
    hideProgressBar: true,
    closeOnClick: true,
    rtl: false,
    pauseOnFocusLoss: false,
    draggable: false,
    pauseOnHover: false,
    style: {
      background: "#000",
      color: "#fff",
      fontSize: "14px",
      width: "auto", // Allow content to size itself
      maxWidth: "98vw", // Prevent overflow on mobile
      wordBreak: "break-word", // Prevent long messages from overflowing
      zIndex: "999999",
    },
  });
}

// export default Toast
